// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var WebStore = require("../../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_GetAppButtons = require("../../../../shared-browser/src/components/BrowserComponents_GetAppButtons.bs.js");
var WebComponents_SimpleCenteredLogoPage = require("../../components/WebComponents_SimpleCenteredLogoPage.bs.js");

var text = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.textAlign(BrowserStyle.center),
      tl: /* [] */0
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XLarge */5, /* Bold */2);
}

var title = Curry._1(BrowserStyle.merge, {
      hd: text,
      tl: {
        hd: Curry._1(BrowserStyle.style, Curry._1(arg(undefined), /* [] */0)),
        tl: /* [] */0
      }
    });

var proAppButtons = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: /* [] */0
    });

var loginButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: /* [] */0
    });

var Styles = {
  text: text,
  title: title,
  proAppButtons: proAppButtons,
  loginButton: loginButton
};

function WebContainers_Login$Presentation(Props) {
  var setView = Props.setView;
  return React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
              children: null
            }, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }), React.createElement(BrowserComponents_Text.make, {
                  className: title,
                  children: "Professionals"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Text.make, {
                  className: text,
                  children: "Access your profile to adjust your availability and payment information by downloading the Qwick Professionals app."
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_GetAppButtons.Professional.make, {
                  className: proAppButtons
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XLarge */6
                }), React.createElement(BrowserComponents_Text.make, {
                  className: title,
                  children: "Businesses"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Text.make, {
                  className: text,
                  children: "Manage and post new jobs, view upcoming shifts, and find new workers."
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Button.make, {
                  actionPriority: /* Primary */0,
                  className: loginButton,
                  onClick: (function (param) {
                      return Curry._1(setView, {
                                  TAG: /* Login */3,
                                  _0: /* Business */0
                                });
                    }),
                  title: "BUSINESS LOGIN"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }));
}

var Presentation = {
  Styles: Styles,
  make: WebContainers_Login$Presentation
};

function mapStateToProps(prim) {
  
}

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = {
    setView: (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                    }), partial_arg, param);
      })
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$1, param);
  };
}

function WebContainers_Login(Props) {
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_Login$Presentation, {
                              setView: param$1.setView
                            });
                })
            });
}

var make = WebContainers_Login;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* text Not a pure module */
